import { AccordionPresentationProps } from "@insite/mobius/Accordion";
import { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import { colorPalette, colorStrings, fontFamilyAlt } from "@waytek/Utilities/variables";
import { css } from "styled-components";

export const accordion: {
    defaultProps?: AccordionPresentationProps;
    sectionDefaultProps?: AccordionSectionPresentationProps;
} = {
    sectionDefaultProps: {
        mergeCss: true,
        headerProps: {
            color: colorStrings.commonGlobalGuardianBlue,
            css: css`
                && {
                    button {
                        border-color: ${colorPalette.common.global.guardianBlue};
                        background: ${colorPalette.common.global.guardianBlue};
                        border-top: solid 1px ${colorPalette.common.global.guardianBlue};
                        margin-bottom: 1px;

                        &:focus {
                            padding: 9px;
                            padding-left: 15px;
                        }

                        &[aria-expanded="true"] {
                            margin-bottom: 0;
                        }
                    }
                }
            `,
        },
        panelProps: {
            css: css`
                border-color: ${colorPalette.common.global.guardianBlue};
            `,
        },
        titleTypographyProps: {
            fontFamily: fontFamilyAlt,
            color: colorPalette.common.global.white,
        },
        toggleIconProps: {
            color: colorStrings.commonGlobalWhite,
            css: css`
                transition: 200ms ease-in-out;
                transition-property: transform;
            `,
        },
    },
};
